import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const Brands = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await api.get('/brands');
        setBrands(response.data);
      } catch (error) {
        console.error('Error fetching brands:', error);
      }
    };
    fetchBrands();
  }, []);

  return (
    <div className="px-4 md:px-12 lg:px-24 py-12">
      <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl tracking-tighter mb-12" data-testid="brands-title">
        Marcas
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {brands.map((brand) => (
          <Link
            key={brand.id}
            to={`/catalog?brand=${brand.name}`}
            data-testid={`brand-${brand.slug}`}
            className="group border border-white/10 hover:border-white/30 p-8 transition-all duration-300 text-center"
          >
            {brand.logo ? (
              <img src={brand.logo} alt={brand.name} className="w-full h-24 object-contain mb-4" />
            ) : (
              <div className="h-24 flex items-center justify-center mb-4">
                <h3 className="font-['Playfair_Display'] text-2xl">{brand.name}</h3>
              </div>
            )}
            <p className="text-xs uppercase tracking-[0.2em] text-white/60 group-hover:text-white transition-colors duration-300">
              Ver productos
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Brands;
